const shareOnWhatsAppFunction = (lang: any, lat: any, message: any, isMap: boolean) => {

  let url = ""
  if (isMap) {
    url = `https://api.whatsapp.com/send?text=${message} 
     thki.sa/app/${lang}/${lat}`;
  } else {
    url = `https://api.whatsapp.com/send?text=${message} 
     thki.sa/app/d/${lang}/${lat}`;
  }

  window.open(url, "_blank");
};
export default shareOnWhatsAppFunction;